"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _reactRefetch = require("react-refetch");

var _crowdaaApi = _interopRequireDefault(require("crowdaa-api"));

var _UserContext = _interopRequireDefault(require("./UserContext"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  _setPrototypeOf(subClass.prototype, superClass && superClass.prototype);

  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.getPrototypeOf || function _getPrototypeOf(o) {
    return o.__proto__;
  };

  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var defaultValue = {
  hasArtistProfile: false,
  profile: {
    username: null
  }
};

var UserContextProvider =
/*#__PURE__*/
function (_React$PureComponent) {
  function UserContextProvider() {
    _classCallCheck(this, UserContextProvider);

    return _possibleConstructorReturn(this, _getPrototypeOf(UserContextProvider).apply(this, arguments));
  }

  _createClass(UserContextProvider, [{
    key: "render",
    value: function render() {
      var userId = this.context.userId;
      var _this$props = this.props,
          children = _this$props.children,
          userFetch = _this$props.userFetch;
      var value;

      if (!userId || userFetch && userFetch.rejected) {
        value = _objectSpread({}, defaultValue, {
          notLogged: true
        });
      } else if (userFetch && userFetch.fulfilled) {
        value = userFetch.value;
      } else {
        value = _objectSpread({}, defaultValue, {
          pending: true
        });
      }

      return _react.default.createElement(_UserContext.default.Provider, {
        value: value
      }, children);
    }
  }]);

  _inherits(UserContextProvider, _React$PureComponent);

  return UserContextProvider;
}(_react.default.PureComponent);

_defineProperty(_defineProperty(_defineProperty(UserContextProvider, "propTypes", {
  children: _propTypes.default.node,
  userFetch: _propTypes.default.object
}), "contextTypes", {
  apiURL: _propTypes.default.string,
  loginToken: _propTypes.default.string,
  userId: _propTypes.default.string
}), "defaultProps", {
  children: undefined,
  userFetch: undefined
});

var _default = _reactRefetch.connect.defaults((0, _crowdaaApi.default)({
  type: 'no-store'
}))(function (props, context) {
  var apiURL = context.apiURL,
      userId = context.userId;

  if (!userId) {
    return {};
  }

  return {
    userFetch: {
      context: context,
      url: new URL("".concat(apiURL, "/users/").concat(userId))
    }
  };
})(UserContextProvider);

exports.default = _default;